'use strict';

// Classes
const classes = {
  hidden: 'tw-hidden',
  is: {
    loading: 'is-loading',
    preferred: 'is-preferred',
    calculating: 'is-calculating',
    visible: 'is-visible',
    selected: 'is-selected',
    open: 'is-open',
    active: 'is-active',
    invalid: 'is-invalid',
    current: 'is-current',
    full: 'is-full',
    loaded: 'is-loaded',
    disabled: 'is-disabled',
    fullscreen: 'is-fullscreen',
    alone: 'is-alone',
    sticky: 'is-sticky',
    zoomed: 'is-zoomed',
    enabled: 'is-enabled',
    filtered: 'is-filtered',
    scrollable: 'is-scrollable',
    fixed: 'is-fixed',
    animated: 'is-animated',
    animatedOut: 'is-animated-out',
    animatedIn: 'is-animated-in',
    locked: 'is-locked',
    empty: 'is-empty',
    available: 'is-available',
    cached: 'is-cached'
  },
  has: {
    error: 'has-error',
    success: 'has-success',
    filtersVisible: 'has-filters-visible',
    subscription: 'has-subscription',
    gross: 'has-gross'
  },
  show: {
    password: 'show-password',
    resumeOrder: 'show-resume-order'
  },
  color: {
    state: {
      success: 'tw-text-state-success',
      error: 'tw-text-state-error'
    }
  },
  gtm: {
    avoidViewed: 'gtm-avoid-viewed'
  },
  not: {
    results: 'not-results'
  },
  text: {
    uppercase: 'tw-uppercase'
  }
};

// Variables
const RECURSIVE_SEARCH_LIMIT = 5;

// Functions

// Add class to element
const addClassToElement = ($element, ...newClasses) => {
  if ($element) {
    $element.classList.add(...newClasses);
  }
};

// Remove class from element
const removeClassToElement = ($element, ...newClasses) => {
  if ($element) {
    $element.classList.remove(...newClasses);
  }
};

// Toggle class to element
const toggleClassToElement = ($element, ...newClasses) => {
  if ($element) {
    $element.classList.toggle(...newClasses);
  }
};

// Check if element has class
const hasClassElement = ($element, classname) => {
  if ($element && $element.classList) {
    return $element.classList.contains(classname);
  }
  // Element does not exist or is invalid
  return null;
};

// Find element by class or parent element until RECURSIVE_SEARCH_LIMIT
const findParentFromClass = ($elem, classToSearch, deep = 0) => {
  if (hasClassElement($elem, classToSearch)) {
    return $elem;
  }

  if ($elem && deep < RECURSIVE_SEARCH_LIMIT) {
    return findParentFromClass($elem.parentNode, classToSearch, deep + 1);
  }

  return null;
};

// Export
export {
  classes,
  addClassToElement,
  removeClassToElement,
  toggleClassToElement,
  hasClassElement,
  findParentFromClass
};
